import {HttpError, UpmEntityType} from '@hconnect/common/types'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {Api} from '../../../../../api'
import {SignalListData} from '../../../types/signal'

export const QueryKey = 'signals'

type ApiEntityType = 'plant' | 'area' | 'production-line' | 'department' | 'equipment'

const upmEntityToApiMapping: Record<UpmEntityType, ApiEntityType> = {
  [UpmEntityType.Plant]: 'plant',
  [UpmEntityType.Area]: 'area',
  [UpmEntityType.ProductionLine]: 'production-line',
  [UpmEntityType.Department]: 'department',
  [UpmEntityType.Equipment]: 'equipment'
}

type UseGetSignalsParams = {
  entityType: UpmEntityType
  entityId: string
  searchTerm?: string | null
}

export const useGetSignals = <T>(
  params: UseGetSignalsParams,
  options?: Omit<UseQueryOptions<SignalListData[], AxiosError<HttpError>, T[]>, 'queryKey'>
) => {
  const {entityType, entityId, searchTerm} = params
  const apiEntityType = upmEntityToApiMapping[entityType]
  return useQuery<SignalListData[], AxiosError<HttpError>, T[]>({
    queryKey: [QueryKey, apiEntityType, entityId, searchTerm],
    queryFn: async () => {
      const path = `/upm/signal/${apiEntityType}/${entityId}?pageSize=1000${
        searchTerm ? '&Term=' + searchTerm : ''
      }`
      return (await Api.axiosInstance.get(path)).data
    },
    placeholderData: (prev) => prev,
    ...options
  })
}
